import React from 'react';

export const HeaderRoutes = ({ title }) => {
    return <div className='header-routes-container' >
        <div className="title-planos">{title}</div>
    </div>
}